import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import Spinner from '@components/molecules/Spinner';
import { useQuery } from '@tanstack/react-query';
import { SortableContainer, SortableElement } from 'react-sortable-hoc';
import { PRODUCT_KEYS } from '@src/types/productType';
import { useSetRecoilState } from 'recoil';
import { pageInputChange } from '@src/recoil/common';
import { CallGetOptionGroup, CallPutOptGroup } from '@library/request/callProduct';
import ScrollTopBtn from '@src/components/molecules/ScrollTopBtn';
import { useMenuPermission } from '@src/recoil/permission';

const OptionSort = () => {
  const [searchParams] = useSearchParams();

  const storeId = searchParams.get('storeID');
  const optionGroupID = searchParams.get('optionGroupID');
  const optionID = searchParams.get('optionID');

  const [loading, setLoading] = useState(false);
  const [sortItem, setSortItem] = useState([]);

  const setIsPageInputChange = useSetRecoilState(pageInputChange);
  const { isNoAuth7 } = useMenuPermission(storeId);

  const { data: optGroup, refetch } = useQuery([PRODUCT_KEYS.OPTIONGROUP, storeId, optionGroupID, optionID], {
    enabled: true,
    staleTime: 0,
    queryFn: async () => {
      try {
        setLoading(true);
        const res = await CallGetOptionGroup(storeId);
        if (res.data) {
          const opt = res.data as any;
          setSortItem(opt.find((v: any) => v.ID === Number(optionGroupID)).children);
        }

        return res.data as any;
      } catch (error) {
        console.log('error', error);
        throw error;
      } finally {
        setLoading(false);
      }
    },
  });

  const onSortEnd = ({ oldIndex, newIndex }: { oldIndex: number; newIndex: number }) => {
    if (isNoAuth7) return;
    const newSortList = [...sortItem];
    const [removed] = newSortList.splice(oldIndex, 1);
    newSortList.splice(newIndex, 0, removed);
    setSortItem(newSortList);
    setIsPageInputChange(true);
  };

  const onClickSave = async () => {
    setLoading(true);

    const target = optGroup.find((v: any) => v.ID === Number(optionGroupID));

    const option = {
      options: [
        {
          optionGroupID: target.ID,
          isPriceOption: target.isPriceOption,
          title: target.title,
          selectType: target.selectType,
          isDisplay: target.isDisplay,
          children: sortItem,
        },
      ],
    };

    try {
      const res = await CallPutOptGroup(storeId, optionGroupID, option);
      if (res.result.code === 1) {
        window.alert(`옵션 순서 설정이 완료되었습니다.`);
        window.history.back();
      }
    } catch (error) {
      console.log('error', error);
      throw error;
    } finally {
      setLoading(false);
    }
  };
  type SortableItemProps = {
    key: string;
    index: number;
    list: any;
  };

  type SortableListProps = {
    items: any;
  };

  const SortableItem = SortableElement<SortableItemProps>(({ list }: SortableItemProps) => {
    return (
      <li className="list-sortable-item" style={{ listStyleType: 'none' }}>
        {list.name}
      </li>
    );
  });

  const SortableList = SortableContainer<SortableListProps>(({ items }: SortableListProps) => {
    return (
      <ul id="sortbleList" className="list-sortble">
        {items.map((item: any, index: number) => {
          return <SortableItem key={`optionID-${item.optionID}`} index={index} list={item} />;
        })}
      </ul>
    );
  });

  return (
    <article id="mArticle" className="art-product menu-sortable-list">
      <div className="view-sort">
        <div className="box-product">
          <strong id="title" className="lab-product">
            {optGroup && optGroup.find((v: any) => v.ID === Number(optionGroupID)).title}
          </strong>
          {sortItem.length > 0 && (
            <SortableList
              items={sortItem}
              onSortEnd={onSortEnd}
              helperClass="list-sortable-item select"
              useDragHandle={false}
            />
          )}
        </div>
      </div>
      <div className="fixedBtnGroup">
        <button type="button" id="btnSubmit" className="btnDone" onClick={onClickSave} disabled={isNoAuth7}>
          저장
        </button>
      </div>
      <ScrollTopBtn />
      <Spinner show={loading} />
    </article>
  );
};

export default OptionSort;
